<div class="bg-background border border-border rounded-xl shadow-sm max-w-[440px] w-full mx-auto">
  <div class="p-10">
    <div class="flex justify-center py-10">
      @if (status === 'loading') {
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      } @else if (status === 'success') {
        <img alt="success" class="dark:hidden max-h-[130px]" src="/assets/media/illustrations/30.svg"/>
        <img alt="success" class="light:hidden max-h-[130px]" src="/assets/media/illustrations/30-dark.svg"/>
      } @else {
        <div class="text-red-500">
           <svg class="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
        </div>
      }
    </div>

    @if (status === 'loading') {
      <h3 class="text-lg font-medium text-mono text-center mb-3">Activating your account...</h3>
      <div class="text-sm text-center text-secondary-foreground mb-7.5">
        Please wait while we verify your registration.
      </div>
    } @else if (status === 'success') {
      <h3 class="text-lg font-medium text-mono text-center mb-3">Account Activated!</h3>
      <div class="text-sm text-center text-secondary-foreground mb-7.5">
        Your email has been successfully verified. You can now sign in to your account.
      </div>
      <div class="flex justify-center mb-5">
        <a class="px-5 py-2.5 rounded-lg font-medium transition-all bg-primary text-primary-foreground hover:bg-primary/90 flex justify-center" routerLink="/auth/sign-in">Go to Sign In</a>
      </div>
    } @else {
      <h3 class="text-lg font-medium text-mono text-center mb-3">Activation Failed</h3>
      <div class="text-sm text-center text-red-500 mb-7.5">
        {{ errorMessage }}
      </div>
      <div class="flex justify-center mb-5">
        <a class="px-5 py-2.5 rounded-lg font-medium transition-all bg-secondary text-secondary-foreground hover:bg-secondary/80 flex justify-center" routerLink="/auth/sign-up">Back to Sign Up</a>
      </div>
    }
  </div>
</div>
